var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeavyRain01 = function SvgHeavyRain01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heavy_rain-01_svg2__a",
    x1: 15.43,
    x2: 183.34,
    y1: 179.15,
    y2: 38.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_rain-01_svg2__a",
    id: "heavy_rain-01_svg2__b",
    x1: 35.28,
    x2: 203.18,
    y1: 202.92,
    y2: 62.68
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_rain-01_svg2__a",
    id: "heavy_rain-01_svg2__c",
    x1: 55.12,
    x2: 223.03,
    y1: 226.68,
    y2: 86.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_rain-01_svg2__a",
    id: "heavy_rain-01_svg2__d",
    x1: 43.56,
    x2: 211.46,
    y1: 212.83,
    y2: 72.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_rain-01_svg2__a",
    id: "heavy_rain-01_svg2__e",
    x1: 63.4,
    x2: 231.31,
    y1: 236.59,
    y2: 96.36
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#heavy_rain-01_svg2__a",
    id: "heavy_rain-01_svg2__f",
    x1: 0.08,
    x2: 167.99,
    y1: 160.78,
    y2: 20.54
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M55.6 163c-7.96 0-14.44-6.48-14.44-14.44 0-9 10.77-20.79 12-22.11l2.44-2.61 2.44 2.61c1.23 1.31 12 13.1 12 22.11 0 7.96-6.48 14.44-14.44 14.44m0-29.17c-3.66 4.51-7.76 10.83-7.76 14.73 0 4.28 3.48 7.76 7.76 7.76s7.76-3.48 7.76-7.76c0-3.9-4.11-10.22-7.76-14.73",
    style: {
      fill: "url(#heavy_rain-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.9 163c-7.96 0-14.44-6.48-14.44-14.44 0-9 10.77-20.79 12-22.11l2.44-2.61 2.44 2.61c1.23 1.31 12 13.1 12 22.11 0 7.96-6.48 14.44-14.44 14.44m0-29.17c-3.66 4.51-7.76 10.83-7.76 14.73 0 4.28 3.48 7.76 7.76 7.76s7.76-3.48 7.76-7.76c0-3.9-4.11-10.22-7.76-14.73",
    style: {
      fill: "url(#heavy_rain-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.19 163c-7.96 0-14.44-6.48-14.44-14.44 0-9 10.77-20.79 12-22.11l2.44-2.61 2.44 2.61c1.23 1.31 12 13.1 12 22.11 0 7.96-6.48 14.44-14.44 14.44m0-29.17c-3.66 4.51-7.76 10.83-7.76 14.73 0 4.28 3.48 7.76 7.76 7.76s7.76-3.48 7.76-7.76c0-3.9-4.11-10.22-7.76-14.73",
    style: {
      fill: "url(#heavy_rain-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.75 200c-7.96 0-14.44-6.48-14.44-14.44 0-9.01 10.77-20.79 12-22.11l2.44-2.61 2.44 2.61c1.23 1.31 12 13.1 12 22.11 0 7.96-6.48 14.44-14.44 14.44m0-29.17c-3.66 4.51-7.76 10.83-7.76 14.73 0 4.28 3.48 7.76 7.76 7.76s7.76-3.48 7.76-7.76c0-3.91-4.1-10.23-7.76-14.73",
    style: {
      fill: "url(#heavy_rain-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.04 200c-7.96 0-14.44-6.48-14.44-14.44 0-9.01 10.77-20.79 12-22.11l2.44-2.61 2.44 2.61c1.23 1.31 12 13.1 12 22.11 0 7.96-6.48 14.44-14.44 14.44m.01-29.17c-3.66 4.51-7.76 10.83-7.76 14.73 0 4.28 3.48 7.76 7.76 7.76s7.76-3.48 7.76-7.76c0-3.91-4.1-10.23-7.76-14.73",
    style: {
      fill: "url(#heavy_rain-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.29 29.43c-3.27 0-6.62.44-10.15 1.35C134.5 11.97 116.05 0 95.21 0 72.13 0 51.9 14.77 44.87 36.75c-.64 1.99.46 4.12 2.45 4.75 2 .64 4.11-.46 4.75-2.45C58.1 20.21 75.44 7.56 95.22 7.56c17.58 0 33.17 9.96 40.71 25.66-5.19 2.37-8.78 5.87-10.98 8.67a3.784 3.784 0 0 0 .63 5.31c.69.55 1.52.81 2.34.81 1.12 0 2.22-.49 2.97-1.44 2.04-2.59 5.64-6.02 11.12-7.59.02 0 .1-.03.13-.04 4.03-1.31 7.68-1.95 11.16-1.95 19.96 0 36.21 16.24 36.21 36.21s-16.25 36.21-36.21 36.21H37.78c-15.04 0-27.28-12.23-27.28-27.27s12.24-27.28 27.28-27.28c2.22 0 4.54.36 7.3 1.14 3.62 1.09 6.97 3.05 9.45 5.51a3.78 3.78 0 0 0 5.34-.01 3.775 3.775 0 0 0-.02-5.34c-3.35-3.34-7.84-5.96-12.63-7.41h-.04c-.01 0-.02-.01-.03-.02-3.46-.97-6.44-1.42-9.38-1.42-19.21 0-34.83 15.63-34.83 34.83s15.63 34.83 34.83 34.83h115.51c24.14 0 43.77-19.63 43.77-43.77s-19.63-43.77-43.77-43.77",
    style: {
      fill: "url(#heavy_rain-01_svg2__f)"
    }
  }));
};
export default SvgHeavyRain01;